import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

/** Email-only sign-in: we email a one-time link (#170). */
export function SignInForm({ onRequest }: { onRequest: (email: string) => Promise<void> }) {
  const [email, setEmail] = useState('');
  const [sentTo, setSentTo] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await onRequest(email.trim());
      setSentTo(email.trim());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'could not send the link');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Paper
      variant="outlined"
      component="form"
      onSubmit={onSubmit}
      sx={{ p: 4, width: '100%', maxWidth: 400 }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Sign in
      </Typography>
      {sentTo ? (
        <Alert severity="success">
          Check {sentTo} for a sign-in link. It works once and expires in 15 minutes.
        </Alert>
      ) : (
        <>
          <TextField
            autoFocus
            fullWidth
            type="email"
            label="Work email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />
          {error ? (
            <Alert severity="error" role="alert" sx={{ mb: 2 }}>
              {error}
            </Alert>
          ) : null}
          <Button type="submit" variant="contained" fullWidth disabled={busy || !email.trim()}>
            Email me a sign-in link
          </Button>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            No account? Contact holly@mollusk.io.
          </Typography>
        </>
      )}
    </Paper>
  );
}
